import { combineReducers } from 'redux'

// ACTIONS
export const FETCH = 'offerzen/notifications/FETCH'
export const FETCH_SUCCESS = 'offerzen/notifications/FETCH_SUCCESS'

export const UPDATE = 'offerzen/notifications/UPDATE'
export const UPDATE_SUCCESS = 'offerzen/notifications/UPDATE_SUCCESS'

// ACTION CREATORS
export const fetch = memberId => ({
  type: FETCH,
  payload: { memberId },
})

export const fetchSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: [...data],
})

export const update = (memberId, params) => ({
  type: UPDATE,
  payload: { memberId, params },
})

export const updateSuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: { ...data },
})

const collection = (state = [], { type, payload }) => {
  switch (type) {
    case UPDATE_SUCCESS:
      return state.map(notification => {
        if (notification.id !== payload.id) return notification

        return {
          ...notification,
          ...payload,
        }
      })

    case FETCH_SUCCESS:
      return [...payload]

    default:
      return state
  }
}

export default combineReducers({
  collection,
})
